export default {
  background_image: 'Obraz tła',
  file_too_large: 'Plik jest za duży. Maksymalny rozmiar to {{max}} MB.',
  upload_failed: 'Przesyłanie nie powiodło się. Spróbuj ponownie.',
};
